// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f63f372e","240":"27017922","455":"c5f2067f","977":"c9d1e323"}[chunkId] + ".chunk.js";
};